export default __webpack_public_path__ + "static/media/skyniche-logo-white.60835dd7.png";